import { defineMessages } from 'react-intl';

export const signUpFormMessages = defineMessages({
  workEmailLabel: {
    defaultMessage: 'Work email',
    id: 'RtR9z+kxpb',
    description: 'Label for work email field on onboarding signup form',
  },
  workEmailPlaceholder: {
    defaultMessage: 'name@company.com',
    id: 'rUbgYWBOYA',
    description: 'Placeholder for work email on onboarding signup form',
  },
  orDivider: {
    defaultMessage: 'or',
    id: 'qKpT3FvTte',
    description: 'Divider between email and social login options on signup form',
  },
  continueWithGoogle: {
    defaultMessage: 'Continue with Google',
    id: 'ypIGHzj4Pt',
    description: 'Button to sign up with Google on onboarding form',
  },
  continueWithApple: {
    defaultMessage: 'Continue with Apple',
    id: 'rr19cAO2tM',
    description: 'Button to sign up with Apple on onboarding form',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'yQOmunBlPV',
    description: 'Primary button to continue with email on onboarding signup form',
  },
  googleLogoAlt: {
    defaultMessage: 'google logo',
    id: '6SJUDWDSX6',
    description: 'Alt text for Google logo on onboarding signup social button',
  },
  appleLogoAlt: {
    defaultMessage: 'apple logo',
    id: 'HO5LaEZ7ra',
    description: 'Alt text for Apple logo on onboarding signup social button',
  },
});
